// extracted by mini-css-extract-plugin
module.exports = {"mortgages-header":"mortgages-header_mortgages-header__62kkI"};